import type { IIntegration } from '../../../../../api';
import { SelectIntegrationGroupsController } from '../../../../../features/SelectIntegrationGroups';
import type { IntegrationSpec } from '../../../../../interfaces/IntegrationSpec';

interface SelectPanelProps {
	integration: IIntegration;
	spec: IntegrationSpec;
}

export function SelectPanel({ integration, spec }: SelectPanelProps) {
	return (
		<SelectIntegrationGroupsController integration={integration} spec={spec} />
	);
}
